export default {
	data() {
		return {
			channelSortValue: 'name-asc',
			channelsSortOptions: [
				{id: 'name-asc', text: this.$gettext('Abecedně A-Z')},
				// {value: 'name-desc', text: this.$gettext('Abecedně Z-A')},
				{id: 'weight-asc', text: this.$gettext('Dle váhy vzestupně')},
				// {value: 'weight-desc', text: this.$gettext('Dle váhy sestupně')},
			]
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/mixins/channels-sort-options.js